
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import {
    Button, Form, Grid
} from 'semantic-ui-react';
import { TextField } from '+/components';
import { useUpsertUnitTypes } from '~/unit-types';
import dayjs from 'dayjs';

const styles = {
    root: {
        padding: '15px'
    }
};

const UnitTypesForm = props => {

    const { initialValues } = props;

    const { mutate: upsertUnitTypes } = useUpsertUnitTypes();


    const onSubmit = async ({ special_type, ...payload }) => {

        payload.property_id = initialValues.property_id;
        payload.last_update = dayjs();
        upsertUnitTypes(payload);
        props.closeModal();

    };

    return (

        <FinalForm

            initialValues={{
                ...initialValues,
                name: initialValues.name,
                bedroom: initialValues.bedroom,
                total_units: initialValues.total_units,
                base_price: initialValues.base_price,
                growth_rate: initialValues.growth_rate,
                date: initialValues.date,
                new_price: initialValues.new_price
            }}
            validate={validate}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, hasValidationErrors, errors, submitError
            }) => (
                <div style={styles.root}>
                    <Form onSubmit={handleSubmit}>
                        <Grid verticalAlign='bottom' padded='vertically'>
                            <Grid.Row>
                                <Grid.Column width='8'>
                                    <TextField name='name' label='Unit Type Name'
                                        required
                                    />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <TextField name='bedroom' label='Bedroom' required />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <TextField name='total_units' label='Total Units' required />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width='4'>
                                    <TextField name='entrata_id' label='Entrata Id' />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <TextField readOnly={true} name='base_price' label='Base Price' />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <TextField readOnly={true} name='growth_rate' label='Growth Rate' />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <TextField readOnly={true} name='date' label='Date' />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width='4'>
                                    <TextField readOnly={true} name='new_price' label='New Price' />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Form.Field>
                            <Button negative onClick={props.closeModal}>
                            Cancel
                            </Button>
                            <Button floated='right' type='submit' disabled={submitting || pristine}>
                            Submit
                            </Button>
                        </Form.Field>
                    </Form>
                </div>
            )}
        />
    );
};

const validate = values => {
    const errors = {};

    if (!values.name) {
        errors.name = 'Required.';
    }

    // if (!values.entrata_id) {
    //     errors.growth_rate = 'Required.';
    // }

    return errors;
};

export default UnitTypesForm;
